import { j as t } from "./jsx-runtime-C5mzlN2N.js";
import { forwardRef as a } from "react";
import l from "styled-components";
import "./components/Theme/themes.es.js";
import "./palettes-Bw24w7AF.js";
import { getPaletteForeground as r, getRadii as c, getPaletteBackground as d, getEffects as u } from "./components/Theme/utils.es.js";
import "./CssBaseline-Bp4jdUgb.js";
import { I as m } from "./CheckIcon-XCAywhAi.js";
import "./components/Icon/countryVariants.es.js";
import { sizeStyles as f, iconSizeStyles as p } from "./components/ButtonClose/styles.es.js";
const g = l.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  border: none;
  
  background-color: transparent;

  color: ${r("quinary.default")};
  
  border-radius: ${c("full")};

  ${(o) => f[o.$size]};
    
  > * {
    ${(o) => p[o.$size]};
  }

  &:hover, &:active {
    background-color: ${d("primary.hover")}
  }

  &:focus {
    outline: none;
    box-shadow: ${u("focusRings.gray.default")};
  }
  
  &:disabled {
    cursor: not-allowed;

    color: ${r("disabled.default")};
  }
`, S = a(
  function(e, i) {
    const {
      size: n = "md",
      ...s
    } = e;
    return /* @__PURE__ */ t.jsx(
      g,
      {
        ref: i,
        $size: n,
        ...s,
        children: /* @__PURE__ */ t.jsx(m, { variant: "close" })
      }
    );
  }
);
export {
  S as B
};
